import { Enum, EnumType } from 'ts-jenum';

@Enum<FeatureEnum>('value')
export class FeatureEnum extends EnumType<FeatureEnum>() {
   static readonly USE_ATTENDANT_CONSOLE = new FeatureEnum('UseAttendantConsole');

   static readonly USE_OPERATOR_CONSOLE = new FeatureEnum('UseOperatorConsole');

   /**
    * User sees appointments / calendar data
    */
   static readonly USE_OUTLOOK_NOTES_INTEGRATION = new FeatureEnum('UseOutlookNotesIntegration');

   static readonly USE_SIP_PRESENCE_INTEGRATION = new FeatureEnum('UseSipPresenceIntegration');

   static readonly USE_EMAIL_AND_TEXTING = new FeatureEnum('UseEmailAndTexting');

   static readonly USE_BUSY_LAMP_FIELD = new FeatureEnum('UseBusyLampField');

   static readonly USE_AGENT_CALL_RECORDING = new FeatureEnum('UseAgentCallRecording');

   static readonly USE_WEB_AGENT = new FeatureEnum('UseWebAgent');

   /**
    * User may manually select 'Pause' (presence State.BUILDIN_STATE_DND_ID =-5).
    */
   static readonly CCO_PERM_USE_PAUSE = new FeatureEnum('CcoPermUsePause');

   static readonly CCO_PERM_EDIT_ORGNUM = new FeatureEnum('CcoPermEditOrgnum');

   static readonly CCO_PERM_EDIT_INFO_FIELD = new FeatureEnum('CcoPermEditInfoField');

   static readonly CCO_PERM_EDIT_CONFIG = new FeatureEnum('CcoPermEditConfig');

   static readonly CCO_PERM_EDIT_CONFIG_OTHER_USER = new FeatureEnum('CcoPermEditConfigOtherUser');

   static readonly CCO_PERM_EDIT_CONFIG_VIEW = new FeatureEnum('CcoPermEditConfigView');

   static readonly CCO_PERM_EDIT_CONFIG_LIST_PERM = new FeatureEnum('CcoPermEditConfigListPerm');

   static readonly CCO_PERM_EDIT_CONFIG_BLF = new FeatureEnum('CcoPermEditConfigBlf');

   static readonly CCO_PERM_EDIT_CONFIG_PROGRAM = new FeatureEnum('CcoPermEditConfigProgram');

   static readonly CCO_PERM_EDIT_CONFIG_KEYWORD = new FeatureEnum('CcoPermEditConfigKeyword');

   /**
    * Settings dialog shows key shortcut configuration.
    */
   static readonly CCO_PERM_EDIT_CONFIG_KEY_CONF = new FeatureEnum('CcoPermEditConfigKeyConf');

   static readonly CCO_PERM_EDIT_CONFIG_OPERATOR_SETTINGS = new FeatureEnum('CcoPermEditConfigOperatorSettings');

   static readonly CCO_PERM_EDIT_CONFIG_QUEUE = new FeatureEnum('CcoPermEditConfigQueue');

   static readonly REPORT_DELETED_ITEMS = new FeatureEnum('ReportDeletedItems');

   static readonly CCO_PERM_MAY_FREELY_DIVERT_SKILL = new FeatureEnum('CcoPermMayFreelyDivertSkill');

   static readonly CCO_PERM_MAY_RESET_VOICEBOX_PIN = new FeatureEnum('CcoPermMayResetVoiceboxPin');

   /**
    * User may freely select to answer any call from his call list.
    */
   static readonly CCO_PERM_PICK_CALL_FROM_CALL_LIST = new FeatureEnum('CcoPermPickCallFromCallList');

   /**
    * User can drop/disconnect call before answering it.
    */
   static readonly CCO_PERM_DISCONNECT_CALL_BEFORE_ANSWER = new FeatureEnum('CcoPermDisconnectCallBeforeAnswer');

   static readonly ADMINISTRATE_EXTERNAL_DIRECTORY = new FeatureEnum('AdministrateExternalDirectory');

   static readonly ADMINISTRATE_INTERNAL_DIRECTORY = new FeatureEnum('AdministrateInternalDirectory');

   static readonly ADMINISTRATE_CALLCENTER = new FeatureEnum('AdministrateCallcenter');

   static readonly ADMINISTRATE_DATA_IMPORTS = new FeatureEnum('AdministrateDataImports');

   /**
    * User may park calls at the agent.
    */
   static readonly PARK_CALL_AT_AGENT = new FeatureEnum('ParkCallAtAgent');

   /**
    * User may park calls at the skill.
    */
   static readonly PARK_CALL_IN_SKILL = new FeatureEnum('ParkCallInSkill');

   static readonly PARK_CALL = new FeatureEnum('ParkCall');

   static readonly SPEEDDIAL = new FeatureEnum('Speeddial');

   static readonly EMAIL_TEMPLATES = new FeatureEnum('EmailTemplates');

   static readonly CCO_PERM_SET_CALL_FORWARD = new FeatureEnum('CcoPermSetCallForward');

   static readonly ADMINISTRATE_PHONETIC = new FeatureEnum('AdministratePhonetic');

   /**
    * User may park message at the Agent
    */
   static readonly PARK_MESSAGE_AT_AGENT = new FeatureEnum('ParkMessageAtAgent');

   /**
    * User may park message at the Skill
    */
   static readonly PARK_MESSAGE_IN_SKILL = new FeatureEnum('ParkMessageInSkill');

   /**
    * Allow to change password.
    */
   static readonly ALLOW_TO_CHANGE_OWN_PASSWORD = new FeatureEnum('AllowToChangeOwnPassword');

   /**
    * User may manually select 'After Call Work' (presence States.BUILDIN_STATE_AFTERCALLWORK_ID= -3).
    */
   static readonly CCO_PERM_MAY_SET_ACW = new FeatureEnum('CcoPermMaySetAcw');

   static readonly REPORTS_EXECUTE_AND_CREATE = new FeatureEnum('ReportsExecuteAndCreate');

   /**
    * User may see also the call & chat history from other Agents.
    */
   static readonly ALLOW_TO_SEE_FOREIGN_HISTORY = new FeatureEnum('AllowToSeeForeignCallHistory');

   /**
    * User may see monitoring status.
    */
   static readonly ALLOW_TO_SEE_MONITORING_STATUS = new FeatureEnum('AllowToSeeMonitoringStatus');

   /**
    * Allow to transfer a call before answering.
    */
   static readonly ALLOW_TRANSFERRING_CALLS_BEFORE_ANSWERING = new FeatureEnum('AllowTransferringCallsBeforeAnswering');

   // features samwin6 seats
   static readonly SAMWIN_7_AGENT = new FeatureEnum('Samwin7Agent');

   static readonly SAMWIN_7_ATTENDANT = new FeatureEnum('Samwin7Attendant');

   static readonly SAMWIN_7_EMAIL = new FeatureEnum('Samwin7Email');

   static readonly SAMWIN_7_REPORTING = new FeatureEnum('Samwin7Reporting');

   /**
    * WebAgent meaning: User can pick calls from the call list which are beyond his skill level.
    */
   static readonly USERS_PICK_CALLS_BEYOND_QUEUE_LEVEL = new FeatureEnum('UsersPickCallsBeyondQueueLevel');

   /**
    * User can see the subjects of Exchange appointments.
    */
   static readonly DO_SHOW_EXCHANGE_APPOINTMENT_SUBJECTS = new FeatureEnum('DoShowExchangeAppointmentSubjects');

   static readonly SAMWIN_7_LINE = new FeatureEnum('Samwin7Line');

   static readonly SAMWIN_7_CHAT = new FeatureEnum('Samwin7Chat');

   static readonly SAMWIN_7_SOCIAL_MEDIA = new FeatureEnum('Samwin7SocialMedia');

   static readonly RESET_OE_CALL_FORWARD_ON_AVAILABLE = new FeatureEnum('ResetOeCallForwardOnAvailable');

   /**
    * WebAgent meaning: User can utilize agent-list brick to its full potential => can barge in into the calls of other Agents
    */
   static readonly PROVIDE_SUPERVISOR = new FeatureEnum('ProvideSupervisor');

   /**
    * WebAgent meaning: User can set an alternative device.
    */
   static readonly CCO_PERM_SET_ALTERNATIVE_DEVICE = new FeatureEnum('CcoPermSetAlternativeDevice');

   /**
    * The user is allowed to reassign a call.
    */
   static readonly ALLOW_TO_REASSIGN_CALL = new FeatureEnum('AllowToReassignCall');

   /**
    * The user is allowed to reassign a mail.
    */
   static readonly ALLOW_TO_REASSIGN_EMAIL = new FeatureEnum('AllowToReassignEmail');

   /**
    * The user is allowed to manually record a call.
    */
   static readonly ALLOW_MANUAL_CALL_RECORDING = new FeatureEnum('AllowManualCallRecording');

   /**
    * Do use 'After Call Work' state for direct inbound calls on operator set
    */
   static readonly DO_USE_ACW_FOR_UNTRIGGERED_INBOUND_CALLS_ON_SET = new FeatureEnum('DoUseAcwForUntriggeredInboundCallsOnSet');

   /**
    * Do use 'After Call Work' state for direct outbound calls on operator set
    */
   static readonly DO_USE_ACW_FOR_UNTRIGGERED_OUTBOUND_CALLS_ON_SET = new FeatureEnum('DoUseAcwForUntriggeredOutboundCallsOnSet');

   /**
    * Do show the 'Required Agents' information for active Skills
    */
   static readonly DO_SHOW_REQUIRED_AGENT_WARNING_FOR_ACTIVE_SKILLS = new FeatureEnum('DoShowRequiredAgentWarningForActiveSkills');

   /**
    * Do show the 'Required Agents' information for manageable Skills
    */
   static readonly DO_SHOW_REQUIRED_AGENT_WARNING_FOR_MANAGEABLE_SKILLS = new FeatureEnum('DoShowRequiredAgentWarningForManageableSkills');

   /**
    * Do show the 'Required Agents' information triggered by other users
    */
   static readonly DO_SHOW_REQUIRED_AGENT_WARNING_TRIGGERED_BY_OTHER_USERS = new FeatureEnum('DoShowRequiredAgentWarningTriggeredByOtherUsers');

   /**
    * Do open custom integration URLs of Skills in a new browser window
    */
   static readonly DO_OPEN_CI_URLS_OF_SKILLS_IN_NEW_WINDOW = new FeatureEnum('DoOpenCustomIntegrationUrlsOfSkillsInNewBrowserWindow');

   /**
    * WebAgent meaning: User can change the brickwall settings, settings of brick instances and change the layout of the brickwall in
    * edit mode.
    */
   static readonly WEB_AGENT_CHANGE_BRICKS_AND_WALL_SETTINGS = new FeatureEnum('WebAgentChangeBricksAndWallSettings');

   /**
    * MS Teams user's samwin user shall automatically be signed-in
    */
   static readonly DO_AUTO_SIGN_IN_MS_TEAMS_USERS_TO_SAMWIN = new FeatureEnum('DoAutoSignInMsTeamsUsersToSamwin');

   /**
    * The user is allowed to use collaborative features of the Rocket.Chat integration.
    * For example: collaborative chats and channels
    */
   static readonly ALLOW_USE_OF_ROCKET_CHAT_COLLABORATION_FEATURES = new FeatureEnum('AllowUseOfRocketChatCollaborationFeatures');

   /**
    * The user is allowed to handle Rocket.Chat livechats.
    */
   static readonly ALLOW_HANDLING_OF_ROCKET_CHAT_LIVECHATS = new FeatureEnum('AllowHandlingOfRocketChatLivechats');

   static readonly DIRECTORY_ADD_CONTACT = new FeatureEnum('DirectoryCreateContact');

   static readonly DIRECTORY_DELETE_CONTACT = new FeatureEnum('DirectoryDeleteContact');

   static readonly DIRECTORY_EDIT_CONTACT = new FeatureEnum('DirectoryUpdateContact');

   private constructor(public value: string) {
      super();
   }
}
